// extracted by mini-css-extract-plugin
var _1 = "Header-moduleactions__uRAy4";
var _2 = "Header-modulecreate___yNRK";
var _3 = "Header-moduleedit__OW1X_";
var _4 = "Header-moduleheader__qfeXB";
var _5 = "Header-moduleheaderText__vHLPv";
export { _1 as "actions", _2 as "create", _3 as "edit", _4 as "header", _5 as "headerText" }
